<template>
  <div v-if="notifs.notificaciones.length">
    <button
      type="button"
      class="fixed flex items-center justify-center bottom-115 size-50 right-12 z-40 bg-orange-500 text-white rounded-full p-12 shadow active:scale-95 transition-transform"
      aria-label="Abrir notificaciones"
      @click="onClickOpen"
    >
      <LucideBell
        :size="24"
        :class="[
          'text-black size-20! -mt-4',
          !hasOpened && notifs.notificaciones.length && 'bell-ring',
        ]"
      />
      <span
        v-if="notifs.notificaciones.length"
        class="flex absolute -top-1 -right-1 bg-red-600 dark:text-white text-black text-xs font-bold rounded-full size-20 flex items-center justify-center"
      >
        {{ notifs.notificaciones.length }}
      </span>
      <span class="sr-only"
        >Hay {{ notifs.notificaciones.length }} notificaciones</span
      >
    </button>

    <Transition name="slide-right">
      <div v-if="isOpen" class="fixed inset-0 z-50 flex justify-end">
        <div class="absolute inset-0 bg-black/40" @click="isOpen = false" />

        <div
          class="relative h-full w-[calc(90vw)] max-w-full bg-white dark:bg-azul-oscuro shadow-xl flex flex-col"
        >
          <div
            class="flex items-center justify-between py-8 px-12 border-b border-gray-200 dark:border-gray-700"
          >
            <h2 class="text-base font-semibold flex items-center gap-8">
              <LucideBell :size="20" />
              Notificaciones
            </h2>
            <button
              type="button"
              class="p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex self-stretch"
              aria-label="Cerrar notificaciones"
              @click="isOpen = false"
            >
              <LucideX :size="24" class="size-24!" />
            </button>
          </div>

          <div class="flex-1 overflow-y-auto">
            <div
              v-if="!notifs.notificaciones.length"
              class="flex flex-col items-center justify-center h-full text-gray-400 dark:text-gray-500 gap-2 py-8 px-12"
            >
              <LucideBell :size="32" />
              <p class="text-sm">No hay notificaciones</p>
            </div>

            <div
              v-else
              v-for="notif in notifs.notificaciones"
              :key="notif._id"
              class="flex items-start gap-6 py-8 px-12 border-b border-gray-100 dark:border-gray-700"
            >
              <LucideBell :size="18" class="flex-none mt-0.5 text-orange-500" />
              <div class="min-w-0">
                <p class="text-sm leading-snug" v-html="notif.titulo" />
                <time
                  class="text-xs text-gray-400 dark:text-gray-500 mt-1 block"
                >
                  {{ formatNotifDate(notif.date) }}
                </time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { useNotificacionesStore } from '~~/stores/notificaciones';
import { formatNotifDate } from '~~/helpers/helpers';

const notifs = useNotificacionesStore();
const isOpen = ref(false);
const hasOpened = ref(false);
const onClickOpen = () => {
  if (!hasOpened.value) {
    hasOpened.value = true;
    umTrackEvent('Notificaciones', 'Abrir');
  }
  isOpen.value = true;
};
</script>

<style scoped>
.slide-right-enter-active,
.slide-right-leave-active {
  transition: opacity 0.3s ease;
}

.slide-right-enter-active > div:last-child,
.slide-right-leave-active > div:last-child {
  transition: transform 0.3s ease;
}

.slide-right-enter-from {
  opacity: 0;
}

.slide-right-enter-from > div:last-child {
  transform: translateX(100%);
}

.slide-right-leave-to {
  opacity: 0;
}

.slide-right-leave-to > div:last-child {
  transform: translateX(100%);
}

.slide-right-enter-to,
.slide-right-leave-from {
  opacity: 1;
}

.slide-right-enter-to > div:last-child,
.slide-right-leave-from > div:last-child {
  transform: translateX(0);
}

.bell-ring {
  animation: bell-ring 1.5s ease-in-out infinite;
}

@keyframes bell-ring {
  0% {
    transform: rotate(0);
  }
  10% {
    transform: rotate(15deg);
  }
  20% {
    transform: rotate(-15deg);
  }
  30% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(5deg);
  }
  60% {
    transform: rotate(-5deg);
  }
  70% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
